import moment from "moment";
import {
    createColumnBoolean,
    createColumnInput,
    createColumnSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";

export const callDocumentStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "DOCUMENT_STATUS", value: searchQuery });

export const callUserObjective = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery })

export const callRequestType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", {
        group: "REQUEST_TYPE",
        value: searchQuery,
        where: [{ name: "key", type: "String", operator: "in", value: ["1", "2", "4"] }]
    });



export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.haz.info.code"),
            dataIndex: "approveCode2",
            width: 210,
            customRender: ({ record }) => <div>
                <div>{i18n.global.t("model.haz.info.documentCode")}: {record.approveCode2}</div>
                <div>{i18n.global.t("model.haz.approveCode")}: {record.approveCode}</div>
                { !record.approveCodeOld ? <span></span> : <div>{i18n.global.t("model.haz.info.approveCodeOld")}: {record.approveCodeOld}</div> }
            </div>,
            search: {
                visible: () => false,
            }
        }),
        createColumnInput({ visible: () => false, title: () => i18n.global.t("model.haz.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnInput({
            visible: () => false,
            title: () => i18n.global.t("model.haz.info.approveCodeOldExample"),
            dataIndex: "approveCodeOld",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            width: 140,
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.info.refOperation"),
            dataIndex: "refOperation.value",
            inputProp: () => ({ list: callUserObjective, optLabel: "value" }),
            width: 75,
            sorter: false,
            search: {
                visible: () => false,
                name: "refOperation.id",
            }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refHazObject"),
            dataIndex: "refHazObject.nameTh",
            width: 140,
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.info.tradeName"),
            dataIndex: "tradeNameTh",
            width: 140,
        }),
        // createColumnSelect({
        //     visible: () => false,
        //     title: () => i18n.global.t("model.haz.refType"),
        //     dataIndex: "refType.value",
        //     inputProp: () => ({ list: callHazType, optLabel: "value" }),
        //     width: 120,
        //     search: { name: "refType.id" }
        // }),
        // createColumnInput({
        //     title: () => i18n.global.t("model.haz.manufacturer"),
        //     dataIndex: "manufacturer",
        //     width: 140,
        //     search: {
        //         visible: () => false,
        //     }
        // }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.info.distributorName"),
            dataIndex: "distributors.refDistributor.fullNameTh",
            dataIndexValue: ({ record }) => {
                const items = record?.distributors?.map(itemName => <div>{itemName.refDistributor.fullNameTh}</div>) || [];
                return <div>
                    {...items}
                </div>
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            width: 140,
            sorter: false,
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.info.refUserCompanyProvince"),
            dataIndex: "refUserCompany.address1List.refProvince.nameTh",
            dataIndexValue: ({ record }) => {
                const items = record?.refUserCompany?.address1List?.map(itemName => <div>{itemName?.refProvince?.nameTh || ''}</div>) || [];
                return <div>
                    {...items}
                </div>
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            width: 110,
            sorter: false,
        }),
        // createColumnDate({
        //     title: () => i18n.global.t("model.haz.effectiveDate"),
        //     dataIndex: "effectiveDate",
        //     align: "center",
        //     search: {
        //         visible: () => false,
        //     }
        // }),
        // createColumnDate({
        //     title: () => i18n.global.t("model.haz.expireDate"),
        //     dataIndex: "expireDate",
        //     align: "center",
        //     search: {
        //         visible: () => false,
        //     }
        // }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            customRender: ({ record }) => {
                let text = record.refStatus?.value;
                let text2 = "";
                if (record.expireDate && moment().diff(record.expireDate, 'days') >= 0) {
                    text2 = " (หมดอายุ)";
                }
                return <div><div>{text}</div><div className="text-danger">{text2}</div></div>
            },
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: {
                visible: () => false,
                name: "refStatus.id"
            },
            align: "center",
            width: 100,
        }),
        createColumnBoolean({
            visible: () => false,
            title: () => i18n.global.t("views.request.isExpire"),
            align: "center",
            search: {
                visible: () => false,
                name: "expireDate",
                type: "Date",
                getOperator: ({ value }) => value?.key === "true" ? "<=" : ">",
                getValue: () => moment().format("YYYY-MM-DD")
            },
        }),
    ];
    return columns;
};